var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[
    'special-offer-banner top-banner-wrap-js',
    {
      'special-offer-banner_mobile': _setup.isMobile,
    },
  ]},[_c('div',{staticClass:"special-offer-banner__img-block"},[_c('img',{class:[
        'special-offer-banner__logo',
        {
          'special-offer-banner__logo_mobile': _setup.isMobile,
        },
      ],attrs:{"src":_vm.logoSrc,"alt":_vm.logoAlt}}),_vm._v(" "),(_setup.isMobile)?_c('span',{staticClass:"special-offer-banner__title special-offer-banner__title_mobile"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"special-offer-banner__text-block"},[(!_setup.isMobile)?_c('span',{staticClass:"special-offer-banner__title special-offer-banner__title_desktop"},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]):_vm._e(),_vm._v(" "),_c('a',{class:[
        'special-offer-banner__link-text',
        {
          'special-offer-banner__link-text_mobile': _setup.isMobile,
        },
      ],attrs:{"aria-label":`${_vm.buttonText} - ${_vm.title}`,"role":"button"},on:{"click":_setup.openSpecialOffer}},[_vm._v("\n      "+_vm._s(_vm.buttonText)+"\n      "),_c('i',{class:['icon icon-i16_next', { icon_mobile: _setup.isMobile }],attrs:{"aria-hidden":"true"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }